import React, { useState } from "react";
import {
  Box,
  Grid,
  Button,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import { FinanceYearlyComparisonTable } from "../../components/Admin/Finance/Charts/FinanceYearlyComparisonTable";
import {  useFinanceYearlyComparison } from "../../hook";
import { FinanceCompareBarChart } from "../../components/Admin";


export function FinanceYearlyComparison() {


  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const [yearA, setYearA] = useState(currentYear);
  const [yearB, setYearB] = useState(currentYear - 1);

  const { data, loading, fetchComparison } = useFinanceYearlyComparison();


  const chartRows = data
  ? [
      { label: "Ventas", a: data.years[String(yearA)].sales, b: data.years[String(yearB)].sales },
      { label: "Pagos", a: data.years[String(yearA)].payments, b: data.years[String(yearB)].payments },
      { label: "Gastos", a: data.years[String(yearA)].expenses, b: data.years[String(yearB)].expenses },
      { label: "Cashflow", a: data.years[String(yearA)].cashflow, b: data.years[String(yearB)].cashflow },
      { label: "Resultado", a: data.years[String(yearA)].result, b: data.years[String(yearB)].result },
    ]
  : [];



  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Comparativo Anual
      </Typography>

      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item>
          <Select
            value={yearA}
            onChange={(e) => setYearA(e.target.value)}
            size="small"
          >
            {years.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item>
          <Select
            value={yearB}
            onChange={(e) => setYearB(e.target.value)}
            size="small"
          >
            {years.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            onClick={() => fetchComparison(yearA, yearB)}
            disabled={loading}
          >
            Comparar
          </Button>
        </Grid>
      </Grid>


      {data && (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12}>
            <FinanceCompareBarChart
              title={`Comparativo anual: ${yearA} vs ${yearB}`}
              data={chartRows}
              aLabel={String(yearA)}
              bLabel={String(yearB)}
            />
          </Grid>
        </Grid>
      )}




      <FinanceYearlyComparisonTable
        data={data}
        yearA={yearA}
        yearB={yearB}
      />
    </Box>
  );
}
